import axios from "axios";
import { encode } from "js-base64";
import BaseApi from "./BaseApi";
import { RDC_Response } from "Src/Types/ReDoc/RDC_Response";
import { ReportCommandType, ReportDataType, ReportResultType, ReportsResponse, ReportsUpdateGroup } from "src/Types/Reports";

/** */
export default class APIReport extends BaseApi {

    /** Запрос на получение группового списка сервисов  */
	static getGroupList = async (): Promise<ReportsResponse> => {
		return await this._getReports( 0 ) as ReportsResponse;
	};

	/** Запрос на обновление списка указанной группы сервисов */
	static updateGroupList = async ( page: number = 0 ): Promise<ReportsUpdateGroup> => {
		return await this._getReports( page ) as ReportsUpdateGroup;
	};

	/** Получат/обновляет список отчетов */
	static getReport = async ( id: string ): Promise<ReportDataType> => {
		const url = window.host + "/WebInterfaceModule/ReportsDesignerController/GetReport/" + id;
		try {
			const request = await fetch( url, {	credentials: "include" });
			if ( request.status === 200 ) {
				return await request.json();
			}
			throw new Error("Ошибка при получении лицензии отчета. Сервер вернул - " + request.statusText );
		}
		catch (error: any) {
			console.warn( error );
			return {
				hasError: true,
				errorMessage: "Ошибка при получении отчета.",
				id: '',
				title: "Ошибка",
				reportTemplate: ""
			}
		}
	};

	/** Получает лицензионный ключ стимулсофта  */
	static getLicense = async (): Promise<RDC_Response<string>> => {
		const url = window.host + "/WebInterfaceModule/ReportsDesignerController/GetLicense";
		try {
			const request = await fetch( url, {
				method: "GET", 
				credentials: "include",
				headers: { "Content-Type": "application/json" }
			});
			if ( request.status === 200 ) {
				return await request.json();
			}
			throw new Error("Ошибка при получении лицензии Stimulsoft'а. Сервер вернул - " + request.statusText );
		}
		catch (error: any) {
			console.warn( error );
			return {
				hasError: true,
				errorMessage: "Ошибка при получении лицензии Stimulsoft'а.",
				result: ""
			}
		}
	};

	/** Запрос за данными для отчета */
	static getData = async ( params: ReportCommandType, controller: AbortController ): Promise<ReportResultType|undefined> => {
		const url = window.host + "/wrd/GetSqlData/";
		try {
			// TODO: Переписать под ES20224
			let str = JSON.stringify(params, undefined, 1);
			str = encode( str );
			str = _ROT13( str );
			const request = await axios.post( url , str, { 
				withCredentials: true,
				signal: controller.signal
			});
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка запроса данных отчета." );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			if ( !controller.signal.aborted ) {
				console.warn( error );
				throw new Error("Ошибка запроса данных отчета." );
			}
		}
	};

	/** Сохраняет отчет  */
	static saveReport = async ( id: string, title: string, reportTemplate: string ): Promise<RDC_Response<string>> => {
		const data = { id, title, reportTemplate };
		const url = window.host + "/WebInterfaceModule/ReportsDesignerController/UpdateReport";
		try {
			const request = await fetch( url, {
				method: "POST", 
				credentials: "include",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify( data )
			});
			if ( request.status === 200 ) {
				return await request.json();
			}
			throw new Error("Ошибка при сохранения отчета. Сервер вернул - " + request.statusText );
		}
		catch (error: any) {
			console.warn( error );
			return {
				hasError: true,
				errorMessage: "Ошибка при сохранения отчета",
				result: ""
			}
		}
	}

	/** Функция получения/обновления списка отчетов */
	static _getReports = async ( page: number ): Promise<any> => {
		const url = window.host + '/WebInterfaceModule/ReportsDesignerController/GetReportsList';
        const requestBody = {
			clientTimezoneOffset: (new Date()).getTimezoneOffset(),
			clientDate: new Date((new Date()).setHours(0, 0, 0, 0)),
			groupBy: "",
			sortBy: "FullName",
			sortOrder: "ASC",
			page
        };
		try {
			const request = await fetch( url, {
				method: "POST", 
				credentials: "include",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(requestBody)
			});
			if ( request.status === 200 ) {
				return await request.json();
			}
			throw new Error("Ошибка при получении списка отчетов. Сервер вернул - " + request.statusText );
		}
		catch (error: any) {
			console.warn( error );
			return {
				hasError: true,
				errorMessage: "Ошибка при получении списка отчетов.",
				count: 0,
				location: null,
				page: 0,
				list: []
			}
		}
	};

};

export const isLetter = ( char: string ): boolean => RegExp(/^\p{L}/,'u').test(char);

export const _ROT13 = ( input: string ): string => {
	let result = "";
	for ( let index = 0; index < input.length; index++ ) {
		const char = input.charCodeAt(index);
		if ( isLetter( input[index] ) ) {
			if ( (char >= 65 && char <= 77) || (char >= 97 && char <= 109) ) {
				result += String.fromCharCode( char + 13 );
			} 
			else {
				result += String.fromCharCode( char - 13 );
			}
		}
		else {
			result += String.fromCharCode( char );
		}
	}
	return result;
}


